import React, { createContext, useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { useAuth } from "./AuthContext";

const TenantContext = createContext({ shop: null, isLoading: false, isError: false });

export const TenantProvider = ({ children }) => {
  const { user, buildAuthHeader, hasAuthToken } = useAuth();

  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ["tenant-shop", user?.user?.id || user?.id],
    enabled: Boolean(user) && hasAuthToken,
    retry: false,
    queryFn: async () => {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/shop/shop/me/`,
        { headers: buildAuthHeader() }
      );
      return response.data;
    },
  });

  return (
    <TenantContext.Provider
      value={{ shop: data || null, isLoading, isError, refetch }}
    >
      {children}
    </TenantContext.Provider>
  );
};

export const useTenant = () => useContext(TenantContext);
